<template>
    <div class="workshop">
        <Navigation/>
        <v-main>
            <v-container>
                <v-row>
                    <v-col cols="12" v-if="loading && !isThemeAja">
                        <v-skeleton-loader type="article, list-item, list-item, list-item" height="500px"></v-skeleton-loader>
                    </v-col>
                    <v-col cols="12" v-else>
                        <WorkshopDetails :color="isThemeAja ? '#4E983C' : 'primary'" ref="WorkshopDetails" v-model="workshop" v-if="workshop.id"/>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>

        <!-- Pop-up rappel de réservation de séances -->
        <SessionReminderPopup v-model="showSessionReminderPopup" />
    </div>
</template>

<script>
import WorkshopDetails from '@/components/workshops/Details'
import SessionReminderPopup from '@/components/workshops/SessionReminderPopup'
import { mapGetters, mapActions } from 'vuex'

const MIN_SESSIONS_THRESHOLD = 12

export default {
    components: {
        WorkshopDetails,
        SessionReminderPopup,
    },
    props: {
        id: { type: [String, Number], required: true },
    },
    data () {
        return {
            ready: false,
            workshop: {},
            loading: false,
            showSessionReminderPopup: false,
        }
    },
    mounted () {
        this.getWorkshop()
    },
    computed: {
        ...mapGetters(['isThemeAja']),
    },
    
    methods: {
        ...mapActions(['setThemeAja']),
        async getWorkshop() {
            this.loading = true;
            try {
                const result = await this.$store.dispatch('workshopRequest', { id: this.id, with: ['user', 'meetings', 'partner.logo'] });
                // Pour un atelier PRO consulté par un pro AJA, on garde le thème courant (l'utilisateur reste dans son contexte AJA)
                const profile = this.$store.getters.getProfile;
                const isProAjaOnProWorkshop = result.data.is_pro && profile.is_aja && this.$acl.check('isProPremium');
                if (!isProAjaOnProWorkshop) {
                    this.setThemeAja(result.data.is_aja ? true : false)
                }
                if (await this.isAuthorizedWorkshop(result.data)) {
                    this.workshop = result.data;
                    // Vérifier si on doit afficher la pop-up de rappel de séances
                    this.checkSessionReminderPopup();
                } else {
                    this.$store.dispatch('setErrors', "Vous n'êtes pas autorisé à accéder à cet atelier.");
                    this.redirectUser()
                }
            } catch (err) {
                if (err.response && err.response.status !== 403) {
                    this.$store.dispatch('setErrors', err.response.data);
                }
            } finally {
                this.loading = false;
            }
        },
        async isAuthorizedWorkshop(workshop) {
            const profile = this.$store.getters.getProfile;

            if(!profile.id) {
                return true
            }
            if (workshop.is_aja === profile.is_aja) {
                return true;
            }
            // Exception : un ADH PRO (y compris pro AJA) peut voir les ateliers PRO non-AJA
            if (workshop.is_pro && this.$acl.check('isProPremium')) {
                return true;
            }

            return false;
        },
        redirectUser() {
            const profile = this.$store.getters.getProfile;
            this.$router.push({name: profile.is_aja ? 'aja-home' : 'Workshops'});
        },
        async checkSessionReminderPopup() {
            // Skip for onCOMMENCE workshops
            if (this.workshop?.workshop_type === 'oncommence') {
                return;
            }

            // Vérifier que l'utilisateur est connecté et est user_premium
            if (!this.$acl.check('isUserPremium')) {
                return;
            }

            const profile = this.$store.getters.getProfile;
            if (!profile.id) {
                return;
            }

            try {
                // Récupérer les séances de l'utilisateur
                const { data: userSubscriptions } = await this.$store.dispatch('getUserSubscribitionsRequest', {
                    user_id: profile.id,
                });

                // Compter uniquement les séances avec statut 'validated'
                const validatedSessionsCount = userSubscriptions.filter(
                    sub => sub.pivot && sub.pivot.status === 'validated'
                ).length;

                // Afficher la pop-up si moins de 12 séances validées
                if (validatedSessionsCount < MIN_SESSIONS_THRESHOLD) {
                    this.showSessionReminderPopup = true;
                }
            } catch (err) {
                // En cas d'erreur, ne pas afficher la pop-up
                console.warn('Impossible de vérifier les séances utilisateur:', err);
            }
        }
    }
}
</script>
